/**
 * Floating chip in the corner of the viewport that shows up when the
 * page has gone idle (no user input for 15 min, or tab is hidden and
 * has since come back). Communicates that the data stream is paused
 * so the user doesn't mistake a stale heatmap for live data — and
 * gives them a one-click resume.
 *
 * Hidden when idle is false. Resume happens automatically on the next
 * mouse / keyboard / touch / scroll event anyway, so the button is a
 * convenience, not a requirement.
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import { useIdle } from '../../contexts/IdleContext';

const IdleChip: React.FC = () => {
  const { idle, resume } = useIdle();
  const location = useLocation();

  // Only surface the chip on authed app routes — public pages don't
  // hold WebSocket connections, so the "paused" framing would just be
  // confusing chrome there.
  if (!location.pathname.startsWith('/app')) return null;
  if (!idle) return null;

  return (
    <button
      type="button"
      className="gv-idle-chip"
      onClick={resume}
      aria-label="Resume live data stream"
    >
      <span className="gv-idle-chip-dot" aria-hidden="true" />
      <span className="gv-idle-chip-text">PAUSED · click to resume</span>
    </button>
  );
};

export default IdleChip;
